export const SWIPE_ACTION_BUTTON_SIZE = 66;
